// extracted by mini-css-extract-plugin
export default {"buttonsMenu":"HeaderFixedButtons-module__buttonsMenu__cH9Vl","buttonsMenuAlignedLeft":"HeaderFixedButtons-module__buttonsMenuAlignedLeft__gipA5"};